export var IMAGE_ASSETS = {
    CAT_ERROR: "/assets/statements-mfe/cat_error.png",
    REQUEST_PAST_STATEMENTS_ICON: "/assets/statements-mfe/past_statements.svg",
};
